import type { ResolutionType } from '@travel/traveler-core/components/DomesticErrorPageNoLabels';
import DomesticErrorPageNoLabels from '@travel/traveler-core/components/DomesticErrorPageNoLabels';
import FaqLink from '@travel/traveler-core/components/DomesticErrorPageNoLabels/FaqLink';
import { Link } from '@travel/ui';

const ERROR_PAGE_LABELS = {
  errorTitleLabel: '大変申し訳ありませんが、このページの表示中に問題が発生しました。',
  followingMethodsLabel: '以下の方法をお試し下さい。',
  helpPagesReferenceLabel: 'また、次のヘルプページをご参照下さい。',
  helpTopPageTextLabel: '楽天トラベル ヘルプ',
  helpTopPageLinkLabel: 'https://travel.faq.rakuten.net/',
};

const RESOLUTION_LIST_LABELS = [
  'しばらく時間をおいてから再度アクセスして下さい。',
  'ブラウザやスマートフォン、パソコンを変えて再度アクセスして下さい。',
];

// const OLD_MYPAGE_LABELS = {
//   text: 'にアクセスすることで、予約が確認できる場合があります。',
//   hyperlinkUrl: 'https://aps1.travel.rakuten.co.jp/portal/my/prv_page.top',
//   hyperlinkText: '旧個人ページ',
// };

const HELP_LIST_LABELS = [
  {
    text: 'エラーが発生した時はどうしたら良いですか？',
    url: 'https://travel.faq.rakuten.net/detail/000031531',
  },
  {
    text: '楽天トラベルの利用に当たって推奨環境はありますか？',
    url: 'https://travel.faq.rakuten.net/detail/000003677',
  },
  {
    text: '楽天トラベルへのお問い合わせ方法と営業時間を確認したいです。',
    url: 'https://travel.faq.rakuten.net/detail/000015419',
  },
];

function ErrorPage() {
  const resolutionList: ResolutionType[] = RESOLUTION_LIST_LABELS.map((resolution) => {
    return {
      id: resolution,
      label: resolution,
    };
  });

  // resolutionList.push({
  //   id: OLD_MYPAGE_LABELS.text,
  //   label: (
  //     <span key={OLD_MYPAGE_LABELS.text}>
  //       <Link
  //         url={OLD_MYPAGE_LABELS.hyperlinkUrl}
  //         label={OLD_MYPAGE_LABELS.hyperlinkText}
  //         haveUnderline
  //       />
  //       {OLD_MYPAGE_LABELS.text}
  //     </span>
  //   ),
  // });

  return (
    <DomesticErrorPageNoLabels
      commonLabels={ERROR_PAGE_LABELS}
      resolutionList={resolutionList}
      helpList={HELP_LIST_LABELS.map((faqItem) => {
        return <FaqLink key={faqItem.text} text={faqItem.text} url={faqItem.url} />;
      })}
      helpTopPageLabel={
        <>
          {`それでも解決しない場合は、`}
          <Link
            url={ERROR_PAGE_LABELS.helpTopPageLinkLabel}
            label={ERROR_PAGE_LABELS.helpTopPageTextLabel}
            haveUnderline
          />
          {`をご確認下さい。`}
        </>
      }
    />
  );
}

export default ErrorPage;
